import { useState } from "react"
import { PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { type SignInResponseDto } from "../../Objects/Generics/SignInResponseDto"
import { useLoad } from "../../context/useLoadContext"
import { useError } from "../../context/useErrorContext"
import { useTranslation } from "react-i18next"

export const useResetPassword = () => {
  const { t } = useTranslation("general")

  const [password, setPassword] = useState("")

  const [confirmPassword, setConfirmPassword] = useState("")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const HandleRecoverPassword = async (
    email: string,
    onSuccess: () => void,
    route: string = API_ROUTES.AUTH.SEND_RECOVER_LINK,
  ) => {
    enableLoad()

    try {
      const response = await PostRequest<SignInResponseDto>(`${route}?email=${encodeURIComponent(email)}`, {})

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const HandleSaveNewPassword = async (
    mail: string,
    code: string,
    onSuccess: () => void,
    route: string = API_ROUTES.AUTH.TRY_CHANGE_PASSWORD,
  ) => {
    enableLoad()

    try {
      const response = await PostRequest<SignInResponseDto>(`${route}`, {
        Email: mail,
        Code: code,
        Password: password,
        ConfirmPassword: confirmPassword,
      })

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    confirmPassword,
    password,
    setConfirmPassword,
    setPassword,
    HandleRecoverPassword,
    HandleSaveNewPassword,
  }
}
